import { Card, Divider } from 'antd'
import { useParams } from 'react-router-dom'

import { useTreatmentServiceGetLastExaminationEndpoint } from 'src/api/queries'
import { useLocales } from 'src/locales'

import { ConsultationFormAnamnesisDetails } from './ConsultationFormAnamnesisDetails'
import { ConsultationFormPhysicalExaminationDetails } from './ConsultationFormPhysicalExaminationDetails'

type Props = {
  isPrimary: boolean
}

export const ConsultationFormDetails = ({ isPrimary }: Props) => {
  const { t } = useLocales()
  const { id } = useParams()

  const { data, isLoading } = useTreatmentServiceGetLastExaminationEndpoint(
    {
      consultationId: String(id)
    },
    [id],
    { enabled: !!id }
  )

  const cardTitle = isPrimary
    ? t('consultation_form.primary_title')
    : t('consultation_form.secondary_title')

  return (
    <Card>
      <Card loading={isLoading} title={cardTitle}>
        {data?.form?.anamnesisSection && (
          <ConsultationFormAnamnesisDetails data={data.form.anamnesisSection} />
        )}

        <Divider />

        {data?.form?.physicalExaminationSection && (
          <ConsultationFormPhysicalExaminationDetails
            data={data.form.physicalExaminationSection}
          />
        )}
      </Card>
    </Card>
  )
}
